import { FC } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { TickerEditMode } from './components/tickerEditMode/TickerEditMode'
import { TickerReadMode } from './components/tickerReadMode/TickerReadMode'
import { TRANSLATION_KEYS } from './translations'

import styles from './Ticker.module.scss'

interface ITickerProps {
  ticker: string
}

export const Ticker: FC<ITickerProps> = ({ ticker }) => {
  const isEditMode = useSelector(selectPublishingMode)

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={TRANSLATION_KEYS.fieldLabel} />
      {!isEditMode && <TickerReadMode ticker={ticker} />}
      {isEditMode && <TickerEditMode ticker={ticker} />}
    </div>
  )
}
